// extracted by mini-css-extract-plugin
export default {"chart":"ShortTermRentalGraph_chart__uXRrz"};